
import halson from '@/services/HALSONResource.coffee'

Client = () ->
  halson
    uid: null
    id: null
    start: null
    end: null
    gender: null
    year: null
    note: 
      ops: []

export default
  activities: halson null
  activity_types: halson null
  are_loaded:
    activities: false
    activity_types: false
    client_list: false
    configs: false
    groups: false
    resources: false
  client_list: halson null
  configs: halson null
  cprop_groups: halson null
  dialog: ''
  resources: null
  selected_client: new Client()
  version: VERSION
  working: false
  xhr_is_loading: false
    
  user:
    first_name: sessionStorage.getItem('first_name')
    last_name: sessionStorage.getItem('last_name')
    username: sessionStorage.getItem('username')
    password: sessionStorage.getItem('password')
    is_logged_in: sessionStorage.getItem('is_logged_in') == "true" || false


// WEBPACK FOOTER //
// ./src/vuex/state.coffee